import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const VERSION = 0;

export const clearDeploymentData = async (appId: string, deploymentId: string) => {
    const url = `${API_URL}/saas/${appId}/deployment/db`;

    const result = await httpNetworking.simpleDELETERequest(url, { params: { deploymentId } }, VERSION);

    return result.data as {};
};
